import React, {
  useRef,
  useState,
} from "react";

import {
  ref,
  uploadBytes,
} from "firebase/storage";

import {
  Box,
  Textarea,
  Button,
  Stack,
  useToast,
} from "@chakra-ui/react";

import { storage } from "../../../firebase/config";
import { addReplyToFirestore } from "./repliesAction";

export default function AddReplyForm({
  projectId,
  currentUser,
}) {
  const [replyText, setReplyText] =
    useState("");

  const [loading, setLoading] =
    useState(false);

  const [files, setFiles] = useState([]);

  const toast = useToast();
  const fileInputRef = useRef(null);

  const handleSubmit = async () => {
    if (!replyText.trim() || !projectId) {
      return;
    }

    setLoading(true);

    try {
      const uploadedFiles = [];

      for (const file of files) {
        const fileExtension =
          file.name.includes(".")
            ? file.name
                .split(".")
                .pop()
                .toLowerCase()
                .replace(/[^a-z0-9]/g, "")
            : "";

        const fileId =
          typeof crypto !== "undefined" &&
          crypto.randomUUID
            ? crypto.randomUUID()
            : `${Date.now()}-${Math.random()
                .toString(36)
                .slice(2)}`;

        const storedFileName = fileExtension
          ? `${fileId}.${fileExtension}`
          : fileId;

        const filePath =
          `projects/${projectId}/replies/` +
          storedFileName;

        const storageReference = ref(
          storage,
          filePath
        );

        await uploadBytes(
          storageReference,
          file,
          {
            contentType:
              file.type ||
              "application/octet-stream",
          }
        );

        uploadedFiles.push({
          originalFileName: file.name,
          storedFileName,
          path: filePath,
          contentType:
            file.type ||
            "application/octet-stream",
          size: file.size,
          uploadDate:
            new Date().toISOString(),
        });
      }

      await addReplyToFirestore({
        reply: replyText.trim(),
        projectId,
        createdBy:
          currentUser?.email
            ?.trim()
            .toLowerCase() ||
          "unknown-user",
        attachments: uploadedFiles,
      });

      setReplyText("");
      setFiles([]);

      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }

      toast({
        title: "Reply added",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      console.error(
        "Reply submission failed:",
        error
      );

      toast({
        title: "Reply could not be added",
        description:
          error.message ||
          "Please try again.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      p={4}
      bg="white"
      borderRadius="md"
      shadow="sm"
      borderWidth="1px"
    >
      <Stack spacing={3}>
        <Textarea
          value={replyText}
          onChange={(event) =>
            setReplyText(event.target.value)
          }
          placeholder="Write a reply..."
          resize="vertical"
        />

        <input
          type="file"
          multiple
          ref={fileInputRef}
          onChange={(event) =>
            setFiles(
              Array.from(event.target.files)
            )
          }
        />

        <Button
          colorScheme="blue"
          onClick={handleSubmit}
          isLoading={loading}
          alignSelf="flex-end"
        >
          Add Reply
        </Button>
      </Stack>
    </Box>
  );
}